import PropTypes from 'prop-types'

import BrandStartOrderModal from './BrandStartOrderModal'
import RetailerStartOrderModal from './RetailerStartOrderModal'

const StartOrderModalWrapper = ({ isAccountTypeRetailer, ...rest }) => {
  if (isAccountTypeRetailer) {
    return <RetailerStartOrderModal {...rest} />
  }
  return <BrandStartOrderModal {...rest} />
}

StartOrderModalWrapper.propTypes = {
  isAccountTypeRetailer: PropTypes.bool.isRequired,
}

export default StartOrderModalWrapper
